import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {CompaniesComponent} from './companies.component';

const routes: Routes = [
  {path: 'targetgroups/companies', component: CompaniesComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class CompaniesRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/companies/companies-routing.module.ts